module.exports = __webpack_public_path__ + "img/BackArrow.99abf07d.svg";